import { applicantFullNameFromFields, selectedOptionText, statusMatchField } from "../utils/status_match_form"

export function matchedReward(criteria, airline, tier) {
  if (!airline || !tier) return null
  return criteria?.reward_by_airline_tier?.[airline]?.[tier] || null
}

export function matchedAirlineKey(criteria, field) {
  if (!field?.value) return null
  if (field.name === "status_match_application[origin_airline]") return field.value

  const programmes = Array.isArray(criteria?.airline_programmes) ? criteria.airline_programmes : []
  if (programmes.length === 1) return programmes[0].key

  const input = normalizedProgramme(field.value)
  return programmes.find((programme) =>
    normalizedProgramme(programme.key) === input || normalizedProgramme(programme.name) === input
  )?.key || null
}

export function reviewSummary(form, {
  emptyLabel,
  selectPrefix,
  defaultProgramme,
  defaultTier,
  pendingTier,
  pendingReward,
  criteria
}) {
  const enteredAirlineField = statusMatchField(form, "origin_airline_input")
  const canonicalAirlineField = statusMatchField(form, "origin_airline")
  const airlineField = enteredAirlineField || canonicalAirlineField
  const matchedAirlineField = canonicalAirlineField?.value ? canonicalAirlineField : airlineField
  const tierField = statusMatchField(form, "origin_tier")
  const programme = selectedOptionText(airlineField, selectPrefix)
  const tier = selectedOptionText(tierField, selectPrefix)
  const memberNumber = statusMatchField(form, "member_number")?.value?.trim()
  const reward = matchedReward(criteria, matchedAirlineKey(criteria, matchedAirlineField), tierField?.value)
  const rewardLine = [reward?.reward_tier, reward?.verified_match_length].filter(Boolean).join(", ")

  return {
    full_name: applicantFullNameFromFields(form) || emptyLabel,
    country: selectedOptionText(statusMatchField(form, "country_of_residence"), selectPrefix) || emptyLabel,
    email: statusMatchField(form, "email")?.value?.trim() || emptyLabel,
    member_number: memberNumber ? spacedDigits(memberNumber) : emptyLabel,
    programme: programme || emptyLabel,
    banner_programme: programme || defaultProgramme,
    tier_pill: tier || emptyLabel,
    banner_tier: tier || defaultTier || pendingTier,
    reward_pill: rewardLine || emptyLabel,
    banner_reward_tier: reward?.reward_tier || pendingReward || pendingTier
  }
}

export function validationReview(root, method, emptyLabel) {
  const selected = root.querySelector(
    `input[name="status_match_application[validation_method]"][value="${method}"]`
  )

  return {
    method: selected?.dataset.validationReviewMethod || emptyLabel,
    status: selected?.dataset.validationReviewStatus || emptyLabel,
    tone: selected?.dataset.validationReviewTone || "sky"
  }
}

function spacedDigits(value) {
  return String(value).replace(/\s/g, "").replace(/(\d{3})(?=\d)/g, "$1 ")
}

function normalizedProgramme(value) {
  return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "")
}
